var map = {
	"./aboutus.svg": 5108,
	"./account.svg": 3602,
	"./address.svg": 683,
	"./appdown.svg": 1325,
	"./assets.svg": 5726,
	"./bank.svg": 7123,
	"./changemoney.svg": 1335,
	"./depositpwd.svg": 8597,
	"./exchange.svg": 8774,
	"./exchangeb.svg": 3368,
	"./home.svg": 4742,
	"./identity.svg": 1591,
	"./invite.svg": 8394,
	"./lang.svg": 9929,
	"./loans.svg": 2322,
	"./lockming.svg": 5916,
	"./market.svg": 9253,
	"./message.svg": 8166,
	"./night_mode.svg": 3245,
	"./options.svg": 8693,
	"./pan1.svg": 6435,
	"./pan2.svg": 5696,
	"./pan3.svg": 2609,
	"./password.svg": 9902,
	"./sharing.svg": 9143,
	"./staking.svg": 4436,
	"./telephone.svg": 8203,
	"./verify.svg": 4218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;